import React, { useEffect, useRef, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
import { purchaseNotices, PurchaseNotice } from '../data/content';
import { IMAGES } from '../data/site';
const SHOW_MS = 5200;
const GAP_MS = 9000;
const FIRST_DELAY_MS = 7000;
export function PurchasePopup() {
  const [notice, setNotice] = useState<PurchaseNotice | null>(null);
  const [dismissed, setDismissed] = useState(false);
  const indexRef = useRef(0);
  useEffect(() => {
    if (dismissed) return;
    let hideTimer: number;
    let loopTimer: number;
    const show = () => {
      const next = purchaseNotices[indexRef.current % purchaseNotices.length];
      indexRef.current += 1;
      setNotice(next);
      hideTimer = window.setTimeout(() => setNotice(null), SHOW_MS);
    };
    const startTimer = window.setTimeout(() => {
      show();
      loopTimer = window.setInterval(show, SHOW_MS + GAP_MS);
    }, FIRST_DELAY_MS);
    return () => {
      window.clearTimeout(startTimer);
      window.clearTimeout(hideTimer);
      window.clearInterval(loopTimer);
    };
  }, [dismissed]);
  const minutesAgo = 2 + indexRef.current % 7;
  return <div aria-live="polite" className="pointer-events-none fixed left-3 top-3 z-50 w-[min(20rem,calc(100vw-1.5rem))] sm:bottom-6 sm:left-5 sm:top-auto" data-id="element-51" data-mp="1fuhaod3l70k6">
      <AnimatePresence data-id="element-52" data-mp="n6lhhid87qs5">
        {notice && !dismissed && <motion.div key={notice.name + indexRef.current} initial={{
        opacity: 0,
        y: -12,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: -8,
        scale: 0.98
      }} transition={{
        duration: 0.26,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-auto flex items-center gap-3 rounded-2xl border border-navy-100 bg-white p-2.5 pr-8 shadow-lift" data-id="element-53" data-mp="n97ongw7g49u">
            <img src={IMAGES.bundle} alt="" className="h-12 w-12 shrink-0 rounded-xl bg-sand object-contain p-0.5" data-id="element-54" data-mp="23kbmcrc66j2u" />
            <div className="min-w-0" data-id="element-55" data-mp="2fneapkvl70te">
              <p className="truncate text-[13px] font-bold leading-tight text-ink" data-id="element-56" data-mp="2fmcvr5bg9u6e">
                {notice.name}
              </p>
              <p className="text-[11.5px] leading-snug text-ink-soft" data-id="element-57" data-mp="2kko57exu22o3">
                acaba de comprar el{' '}
                <span className="font-semibold text-ink" data-id="element-58" data-mp="1ry3gyncnm6or">DVO Clinical Workflow Builder™</span>
              </p>
              <p className="mt-0.5 flex items-center gap-1 text-[10.5px] font-semibold uppercase tracking-wide text-go" data-id="element-59" data-mp="1wwwv8hzrm1pz">
                <CheckCircle2Icon className="h-3 w-3" aria-hidden="true" data-id="element-60" data-mp="21vznf1uncdgj" />
                {notice.city}, {notice.country} · hace {minutesAgo} min
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} aria-label="Cerrar notificación" className="absolute right-1.5 top-1.5 rounded-full p-1 text-ink-muted transition-colors duration-150 ease-out hover:bg-sand hover:text-ink" data-id="element-61" data-mp="197u7csejfcn1">
              <XIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-62" data-mp="3nf3f6i4d673f" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}